import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pictos/header/picto_logout_red.svg")